
































































































































































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import FieldSelectModal from '@/app/components/Plant/FieldSelectModal.vue'
import Loading from '@/app/components/Common/Loading.vue'
import NoticeModal from '@/app/components/Common/NoticeModal.vue'
/* api */
import MachineDetailApi from '@/app/model/api/machineDetailApi'
import MachineCreateApi from '@/app/model/api/machineCreateApi'
import MachineEditApi from '@/app/model/api/machineEditApi'
import MachineDeleteApi from '@/app/model/api/machineDeleteApi'
import MachineRentListApi from '@/app/model/api/machineRentListApi'
import GetMachineImgApi from '@/app/model/api/getMachineImgApi'
/* module */
import Local from '@/app/module/local'
import CommonClass from '@/app/module/common'
import Validator from '@/app/module/validator'
import Session from '@/app/module/session'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'
import DateClass from '@/app/module/date'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    ErrorInfo,
    ErrorModal,
    Error409Modal,
    DeleteModal,
    Loading,
    FieldSelectModal,
    NoticeModal,
    Datepicker
  }
})
export default class MachineCreate extends Vue {
  private errorMessages: any = ''
  private alertText: string = ''
  private alertTitle: string = ''
  private noticeMessage: string = '<p>ステータスが利用不可に変更されました。<br/>未完了の機械貸出情報があるため、確認してください。</p>'
  private constantValue: any = []
  private displayImg: any = ''
  private stasusSelected: any = [
    { text: '利用可', value: 0 },
    { text: '利用不可', value: 1 }
  ]
  private machineType: number|null = null
  private machineData: any = {
    is_valid: 0,
    machine_name: '',
    machine_type: null,
    buy_date: '',
    model: '',
    serial_number: '',
    maker_address: '',
    image_path: null,
    working_width: null,
    working_height: null,
    weight: null,
    working_time: null,
    working_performance: null,
    remarks: ''
  }
  /* 表示非表示 */
  private show400ErrorMessage: boolean = false
  private showDeleteModal: boolean = false
  private showImgDeleteModal: boolean = false
  private showNoticeModal: boolean = false
  private showLoading: boolean = true
  private isEdit: boolean = false
  private showError409Modal: boolean = false
  private isInitialDisplay: boolean = true
  /* datepicker */
  private japanese: any = ja
  private form: any = 'yyyy-MM-dd'

  created () {
    // セレクトボックス情報取得
    this.constantValue = JSON.parse(Local.getConstantValue()!)

    if (this.$route.path === '/master/machine/create') {
      this.isEdit = false
      this.showLoading = false
    } else {
      this.isEdit = true
      this.getMachineList()
    }
  }

  private doDelete () {
    this.doMachineDelete()
  }

  private closeDeleteModal () {
    this.showDeleteModal = false
  }

  private closeImgDeleteModal () {
    this.showImgDeleteModal = false
  }

  private changeIsValid () {
    if (this.isEdit && this.machineData.is_valid === 0) {
      this.getMachineRentList()
    }
  }

  private getMachineRentList () {
    (async () => {
      const data = {
        word: '',
        order_name: 'created_at',
        sort: false,
        step: null,
        rent_status: null,
        group_id: null,
        machine_id: this.$route.params.machine_id,
        machine_type: null,
        created_at: null,
        created_by: null,
        created_type: null,
        rent_start_date: null,
        rent_end_date: null,
        use_start_date: null,
        use_end_date: null,
        limit: null,
        page: 1
      }

      const result = await MachineRentListApi.getMachineRentList(data)

      if (result.isOk()) {
        if (result.getPayload().total_count !== 0) {
          this.showNoticeModal = true
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  // 画像
  private changeImg (e: any) {
    if (e.target.files[0] !== undefined) {
      this.machineData.image_path = e.target.files[0]
      const reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      reader.onload = () => {
        this.displayImg = reader.result
      }
    }
  }

  private deleteImg () {
    this.displayImg = ''
    this.machineData.image_path = null
    let el: any = document.getElementById('file')
    el.value = ''
    this.showImgDeleteModal = false
  }

  // 半角数字、-、.以外入力制限
  private inputCheck (key1: string) {
    let before = String(this.machineData[key1])

    let tmp
    let after: any
    if (before === null) {
      after = null
    } else {
      tmp = before.replace(/[^-.0-9]/g, '')
      tmp = tmp.split('').reverse().join('')
      tmp = tmp.replace(/-(?=.)|\.(?=.*\.)/g, '')
      after = tmp.split('').reverse().join('')
    }

    if (key1 === 'planting_group_actual') {
      if (isNaN(parseFloat(after))) {
        this.machineData[key1] = null
      } else {
        this.machineData[key1] = parseFloat(after)
      }
    } else {
      if (isNaN(parseFloat(after))) {
        this.machineData[key1] = null
      } else {
        this.machineData[key1] = parseFloat(after)
      }
    }
  }

  private doSave () {
    /* バリデーションチェック */
    if (!this.isMachineCreate()) {
      window.scrollTo({ top: 0, behavior: 'auto' })
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      return
    } else {
      this.show400ErrorMessage = false
    }
    this.showLoading = true

    let data: any = {}
    for (let i in this.machineData) {
      if (this.machineData[i] !== null) {
        data[i] = this.machineData[i]
      }
    }
    // 整形
    if (data.buy_date !== '') {
      data.buy_date = DateClass.dateToStringYmd(data.buy_date, '-')
    }
    data.image = data.image_path

    if (this.isEdit) {
      if (this.beforeImagePathFlag && data.image_path === undefined) {
        data.image_is_delete = 1
      } else {
        data.image_is_delete = 0
      }
      this.machineEdit(data)
    } else {
      this.machineCreate(data)
    }
  }

  private beforeImagePathFlag: boolean = false

  private getMachineList () {
    (async () => {
      const result = await MachineDetailApi.getMachineDetail(this.$route.params.machine_id)
      if (result.isOk()) {
        this.machineData = result.getPayload().machine
        this.machineData.is_machine_rent = true
        // datepiker用に整形
        if (this.machineData.buy_date !== '' && this.machineData.buy_date !== null) {
          this.machineData.buy_date = new Date(this.machineData.buy_date)
        } else if (this.machineData.buy_date === null) {
          this.machineData.buy_date = ''
        }
        // 画像を取得
        if (this.machineData.image_path !== null) {
          this.beforeImagePathFlag = true
          this.getDefaultImg()
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showLoading = false
    })()
  }

  private async getDefaultImg () {
    if (this.machineData.image_path !== null && this.machineData.image_path !== '') {
      // this.showImgLoading = true
      const result = await GetMachineImgApi.getMachineImgData(this.$route.params.machine_id)
      // resultがオブジェクト型の場合、エラーで画像が存在しないため「登録なし」を表示
      if (typeof result === 'object') {
        this.machineData.image_path = null
      } else {
        this.displayImg = String(result)
      }
    }
  }

  // 機械登録
  private async machineCreate (data: any) {
    const result = await MachineCreateApi.doMachineCreate(data)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '機械登録が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/machine').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'POST', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private async machineEdit (data: any) {
    const result = await MachineEditApi.doMachineEdit(this.$route.params.machine_id, data)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '機械編集が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/machine/' + this.$route.params.machine_id).catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private isMachineCreate () {
    // リセット
    this.errorMessages = {}

    const machineNameFlag = Validator.validateInputMachineName('machineNameErrorMessage', this.machineData.machine_name)
    const machineTypeFlag = Validator.validateInputMachineType('machineTypeErrorMessage', this.machineData.machine_type)
    const modelFlag = Validator.validateInputModel('modelErrorMessage', this.machineData.model)
    const serialNumberFlag = Validator.validateInputSerialNumber('serialNumberErrorMessage', this.machineData.serial_number)
    const makerAddressFlag = Validator.validateInputMakerAddress('makerAddressErrorMessage', this.machineData.maker_address)
    const remarksFlag = Validator.validateInputRemarks('remarksErrorMessage', this.machineData.remarks)
    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())

    let isError = true
    if (this.machineData.image_path !== null) {
      if (this.machineData.image_path.type !== undefined &&
        this.machineData.image_path.type !== 'image/png' &&
        this.machineData.image_path.type !== 'image/jpeg') {
        this.$set(this.errorMessages, 'ImageErrorMessage', '許可されている拡張子ではありません。(登録できる拡張子は .jpeg、.jpg、.pngです)')
        isError = false
      }
    }
    if (this.machineData.working_width !== null) {
      if (this.machineData.working_width < 0 || this.machineData.working_width > 1000000) {
        this.$set(this.errorMessages, 'workingWidthErrorMessage', '作業幅は0以上1,000,000以下の範囲で入力してください。')
        isError = false
      } else if (!Number.isInteger(this.machineData.working_width)) {
        this.$set(this.errorMessages, 'workingWidthErrorMessage', '作業幅は整数で入力してください。')
        isError = false
      }
    }
    if (this.machineData.working_height !== null) {
      if (this.machineData.working_height < 0 || this.machineData.working_height > 1000000) {
        this.$set(this.errorMessages, 'workingHeightErrorMessage', '作業部全高は0以上1,000,000以下の範囲で入力してください。')
        isError = false
      } else if (!Number.isInteger(this.machineData.working_height)) {
        this.$set(this.errorMessages, 'workingHeightErrorMessage', '作業部全高は整数で入力してください。')
        isError = false
      }
    }
    if (this.machineData.weight !== null) {
      if (this.machineData.weight < 0 || this.machineData.weight > 10000) {
        this.$set(this.errorMessages, 'weightErrorMessage', '質量は0以上10,000以下の範囲で入力してください。')
        isError = false
      } else if (!Number.isInteger(this.machineData.weight)) {
        this.$set(this.errorMessages, 'weightErrorMessage', '質量は整数で入力してください。')
        isError = false
      }
    }
    if (this.machineData.working_time !== null) {
      let decimalPointLength = String(this.machineData.working_time).split('.')
      if (this.machineData.working_time < 0 || this.machineData.working_time > 10000) {
        this.$set(this.errorMessages, 'workingTimeErrorMessage', '稼働時間は0以上10,000以下の範囲で入力してください。')
        isError = false
      } else if (decimalPointLength[1] !== undefined && decimalPointLength[1].length > 1) {
        this.$set(this.errorMessages, 'workingTimeErrorMessage', '稼働時間小数点第1位までの範囲で入力してください。')
        isError = false
      }
    }
    if (this.machineData.working_performance !== null) {
      let decimalPointLength = String(this.machineData.working_performance).split('.')
      if (this.machineData.working_performance < 0 || this.machineData.working_performance > 10000) {
        this.$set(this.errorMessages, 'workingPerformanceErrorMessage', '処理性能は0以上10,000以下の範囲で入力してください。')
        isError = false
      } else if (decimalPointLength[1] !== undefined && decimalPointLength[1].length > 1) {
        this.$set(this.errorMessages, 'workingPerformanceErrorMessage', '処理性能小数点第1位までの範囲で入力してください。')
        isError = false
      }
    }

    return machineNameFlag && machineTypeFlag && modelFlag && serialNumberFlag && makerAddressFlag && remarksFlag && isError
  }

  private doMachineDelete () {
    (async () => {
      this.showLoading = true
      const result = await MachineDeleteApi.doMachineDelete(this.$route.params.machine_id)

      if (result.isOk()) {
        this.$store.commit('alertState/setAlertMessage', { type: 0, text: '機械を削除しました。' })
        this.$store.commit('alertState/setAlertFlag', true)
        this.$router.push('/master/machine').catch(e => {})
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'DELETE', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showDeleteModal = false
      this.showLoading = false
    })()
  }

  private doCancel () {
    if (this.isEdit) {
      this.$router.push('/master/machine/' + this.$route.params.machine_id).catch(e => {})
    } else {
      this.$router.push('/master/machine').catch(e => {})
    }
  }
}
